import { Container, Link, Text } from '@doist/marketist'

import { Interpolate } from 'components'
import { useTranslation } from 'next-i18next'

import { appendSlackAltUTM } from '../appendSlackAlternativeUTM'

import css from './FeatureSection.module.css'

export function FeatureSection() {
    const { t } = useTranslation('slackalternative')

    return (
        <Container width="sm" className={css.featureList}>
            <Feature
                posterSrc="/assets/slack-alternative/features/illustration_beyond-slack.jpg"
                videoSrc="/assets/slack-alternative/features/beyond_slack.mp4"
                height={269}
                title={t('slack.title')}
            >
                <Text size="body-base" className={css.featureBody}>
                    <Interpolate
                        t={t}
                        i18nKey="slack.body"
                        mapping={{
                            link: (
                                <Link
                                    href={appendSlackAltUTM('/customer-stories')}
                                    target="_blank"
                                />
                            ),
                        }}
                    />
                </Text>
            </Feature>
            <Feature
                posterSrc="/assets/slack-alternative/features/illustration_made-by-doist.jpg"
                videoSrc="/assets/slack-alternative/features/by_doist.mp4"
                height={247}
                title={t('doist.title')}
            >
                <Text size="body-base" className={css.featureBody}>
                    <Interpolate
                        t={t}
                        i18nKey="doist.body"
                        mapping={{
                            link: (
                                <Link
                                    href={appendSlackAltUTM(
                                        'https://blog.doist.com/no-exit-strategy/',
                                    )}
                                    target="_blank"
                                />
                            ),
                        }}
                    />
                </Text>
            </Feature>
            <Feature
                posterSrc="/assets/slack-alternative/features/illustration_many-time-zones.jpg"
                videoSrc="/assets/slack-alternative/features/timezones.mp4"
                height={208}
                title={t('timezones.title')}
            >
                <Text size="body-base" className={css.featureBody}>
                    <Interpolate
                        t={t}
                        i18nKey="timezones.body"
                        mapping={{
                            link: (
                                <Link
                                    href={appendSlackAltUTM('/customer-stories')}
                                    target="_blank"
                                />
                            ),
                        }}
                    />
                </Text>
            </Feature>
            <Feature
                posterSrc="/assets/slack-alternative/features/illustration_access-to-information.jpg"
                videoSrc="/assets/slack-alternative/features/remote_pages.mp4"
                height={171}
                title={t('independent.title')}
            >
                <Text size="body-base" className={css.featureBody}>
                    {t('independent.body')}
                </Text>
            </Feature>
        </Container>
    )
}

type FeatureProps = {
    posterSrc: string
    videoSrc: string
    title: string
    children: React.ReactNode
    height: number
}

export function Feature({ posterSrc, videoSrc, title, height, children }: FeatureProps) {
    return (
        <div className={css.feature}>
            <video
                width={400}
                height={height}
                poster={posterSrc}
                className={css.featureVideo}
                autoPlay
                playsInline
                muted
                loop
            >
                <source src={videoSrc} type="video/mp4" />
            </video>
            <Text tag="h3" size="major-base" className={css.featureTitle}>
                {title}
            </Text>
            {children}
        </div>
    )
}
